module.exports = __webpack_public_path__ + "static/flags/LS-0801598d45c7e925c4825bdd59d18f3b.gif";